import React from "react";
import { Link } from "react-router-dom";
import BackButton from "../components/common/BackButton";

const TermsAndConditions = () => {
  return (
    <div className="container text-white mt-3">
      <div className="mb-4">
        <BackButton />
      </div>
      
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <h1 className="text-center mb-4">Términos y Condiciones</h1>
          <p className="text-center text-muted mb-5">
            Última actualización: {new Date().toLocaleDateString('es-ES', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>

          <div className="terms-content">
            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">1. Aceptación de Términos</h2>
              <p>
                Al acceder y utilizar la aplicación Billy Browns, usted acepta 
                estar legalmente obligado por estos Términos y Condiciones. Si no está de acuerdo 
                con alguno de estos términos, no debe utilizar nuestra aplicación.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">2. Descripción del Servicio</h2>
              <p>
                Billy Browns es una aplicación de pedidos de hamburguesas que permite a los usuarios:
              </p>
              <ul>
                <li>Navegar por nuestro menú de hamburguesas y productos</li>
                <li>Personalizar pedidos con diferentes tamaños, toppings y acompañamientos</li>
                <li>Realizar pedidos en línea</li>
                <li>Gestionar su perfil de usuario</li>
                <li>Recibir actualizaciones sobre sus pedidos</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">3. Registro de Usuario</h2>
              <p>
                Para utilizar ciertos servicios de la aplicación, debe crear una cuenta proporcionando 
                información veraz, actual y completa. Usted es responsable de mantener la confidencialidad 
                de su cuenta y contraseña.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">4. Recopilación y Uso de Datos</h2>
              <h3 className="h5 mb-2">4.1 Datos que Recopilamos</h3>
              <p>Recopilamos los siguientes tipos de información:</p>
              <ul>
                <li><strong>Información de registro:</strong> Nombre, correo electrónico, teléfono</li>
                <li><strong>Información de pedidos:</strong> Historial de pedidos, preferencias alimentarias</li>
                <li><strong>Información de uso:</strong> Cómo interactúa con la aplicación</li>
              </ul>

              <h3 className="h5 mb-2 mt-4">4.2 Uso de sus Datos</h3>
              <p>Utilizamos su información para:</p>
              <ul>
                <li>Procesar y gestionar sus pedidos</li>
                <li>Mejorar nuestros servicios y experiencia de usuario</li>
                <li>Comunicarnos con usted sobre sus pedidos</li>
                <li><strong className="text-warning">Enviar promociones, ofertas especiales y publicidad por correo electrónico</strong></li>
                <li>Realizar análisis y estudios de mercado</li>
                <li>Cumplir con obligaciones legales</li>
              </ul>

              <h3 className="h5 mb-2 mt-4">4.3 Marketing por Correo Electrónico</h3>
              <p className="bg-dark p-3 rounded">
                <strong>Al aceptar estos términos, usted consiente expresamente que Billy Browns 
                pueda utilizar su dirección de correo electrónico para enviarle:</strong>
              </p>
              <ul>
                <li>Promociones y ofertas especiales</li>
                <li>Nuevos productos y menús</li>
                <li>Encuestas de satisfacción</li>
                <li>Noticias y actualizaciones de la empresa</li>
                <li>Publicidad personalizada basada en sus preferencias</li>
              </ul>
              <p>
                <em>Puede darse de baja de estas comunicaciones en cualquier momento utilizando 
                el enlace de cancelación incluido en cada correo electrónico.</em>
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">5. Protección de Datos</h2>
              <p>
                Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger 
                su información personal contra acceso no autorizado, alteración, divulgación o destrucción.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">6. Compartir Información</h2>
              <p>No vendemos, intercambiamos o transferimos su información personal a terceros, excepto:</p>
              <ul>
                <li>Con proveedores de servicios que nos ayudan a operar la aplicación</li>
                <li>Cuando sea requerido por ley</li>
                <li>Para proteger nuestros derechos y seguridad</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">7. Sus Derechos</h2>
              <p>Usted tiene derecho a:</p>
              <ul>
                <li>Acceder a su información personal</li>
                <li>Corregir datos inexactos</li>
                <li>Solicitar la eliminación de sus datos</li>
                <li>Oponerse al procesamiento de sus datos</li>
                <li>Retirar su consentimiento en cualquier momento</li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">8. Pedidos y Pagos</h2>
              <p>
                Al realizar un pedido, usted confirma que toda la información proporcionada es 
                precisa. Los precios están sujetos a cambios sin previo aviso. Nos reservamos 
                el derecho de rechazar o cancelar pedidos por cualquier motivo.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">9. Limitación de Responsabilidad</h2>
              <p>
                Billy Browns no será responsable por daños indirectos, incidentales, especiales 
                o consecuentes que resulten del uso de la aplicación. Nuestra responsabilidad 
                máxima no excederá el valor del pedido en cuestión.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">10. Modificaciones</h2>
              <p>
                Nos reservamos el derecho de modificar estos términos en cualquier momento. 
                Las modificaciones entrarán en vigencia inmediatamente después de su publicación 
                en la aplicación. El uso continuado de la aplicación constituye la aceptación 
                de los términos modificados.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3 text-warning">11. Ley Aplicable</h2>
              <p>
                Estos términos se rigen por las leyes de Argentina. Cualquier disputa será 
                resuelta en los tribunales competentes de la jurisdicción correspondiente.
              </p>
            </section>
          </div>

          <div className="text-center mt-5 mb-4">
            <Link to="/login" className="btn btn-warning btn-lg">
              Volver al Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
